import React, { useEffect } from "react";
import { slideUpStyle } from "src/components/molecules/ModalBottom";

type Props = {
  message: string;
  open: boolean;
  onClose: () => void;
  px: (n: number) => number;
};

const Toast: React.FC<Props> = ({ message, open, onClose, px }) => {
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(onClose, 1500); // 2초 후 자동 닫힘
    return () => clearTimeout(timer);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <style>{slideUpStyle}</style>
      <div
        style={{
          position: "fixed",
          bottom: px(80),
          left: "50%",
          transform: "translate(-50%, 0)",
          opacity: 0,
          background: "rgba(75, 85, 99, 0.9)",
          color: "#fff",
          padding: "16px",
          fontSize: px(13),
          display: "flex",
          alignItems: "center",
          gap: px(6),
          borderRadius: 999,
          outline: "1px rgba(255, 255, 255, 0.10) solid",
          zIndex: 1001,
          width: "87%",
          maxWidth: "45rem",
          textAlign: "center",
          whiteSpace: "pre-line",
          animation: "slideUp 0.4s ease-out forwards",
        }}
      >
        <svg
          width={px(14)}
          height={px(14)}
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>
        {message}
      </div>
    </>
  );
};

export default Toast;
